var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmex = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M599 601H99V101h500v500z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599 601v-79.227h-60.32l-31.057-34.34-31.213 34.34H277.527V361.727h-64.191l79.622-180.193h76.788l27.411 61.731v-61.731h95.049l16.503 46.518 16.611-46.518H599V101H99v500h500zm-50.16-99.265H599l-66.353-70.364L599 361.807h-49.362l-40.977 44.778-40.583-44.778h-50.172l65.965 69.964-65.965 69.964h48.776l41.178-45.177 40.98 45.177zm11.735-70.305L599 472.309v-81.417l-38.425 40.538zm-223.627 37.922v-21.79h78.957v-31.584h-78.957v-21.787h80.955v-32.384H298.766v139.928h119.137v-32.383h-80.955zm224.27-127.851H599V201.573h-58.771l-31.385 87.153-31.183-87.153h-59.768v139.928h37.779v-97.949l35.983 97.949h33.581l35.982-98.151v98.151zm-186.303 0h42.978l-61.765-139.928h-49.176l-61.771 139.928h41.979l11.596-27.985h64.365l11.794 27.985zm-24.985-59.37h-37.983l18.992-45.776 18.991 45.776z",
    fill: "#006fcf"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmex);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/amex.af6d47eca8fa1eb0d1997f873488b223.svg";